import { render } from "./NewSite.vue?vue&type=template&id=c525a44e&scoped=true"
import script from "./NewSite.vue?vue&type=script&lang=js"
export * from "./NewSite.vue?vue&type=script&lang=js"

import "./NewSite.vue?vue&type=style&index=0&id=c525a44e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c525a44e"]])

export default __exports__